export const hidden_xs = { display: { 'xs': 'none', 'sm':'table-cell'}};
export const hidden_sm = { display: { 'xs': 'none', 'md':'table-cell'}};
export const hidden_md =   { display: { 'xs': 'none', 'lg':'table-cell'}};
export const hidden_lg =   { display: { 'xs': 'none', 'xl':'table-cell'}};